<template>
    <div>
        <div class="nav">
            <page-navigation v-bind:step="currentStep"></page-navigation>
        </div>
        <div class="content_main">
          <div style="overflow: hidden;">
            <h3 class="line_blue" style="float: left;">门店运营参数配置</h3>
            <div id="root" style="float: left;">
                   <div class="element-a" @mouseover="gifShow()" @mouseleave="gifHidden()" style="float: right; padding-left:10px; padding-top:1px;">
                      <img class="information"  src="../../assets/tipp_icon.png" style="float: right;">
                      </div>
                       <div class="gif-wrap">
                         <img class="gif" src="../../assets/step 2.gif" id="gif" v-show="ifShowB"
             @mouseover="gifMouseOver" @mouseleave="gifMouseLeave">
                     </div>
                  </div>
          </div>
            <div class="top_panel">
                <div class="top_panel_left">
                    <span>当前数据：上传于</span>
                    <span>{{time}}</span>
                </div>
                <div class="top_panel_right">
                    <label id="upload" class="btn btn_small btn_black_color btn_label">
                        <input type="file" ref="upload" @change="upload">上传数据
                    </label>
                    <!--<button class="btn_small btn_black_color" v-on:click="upload(e)"></button>-->
                    <button class="btn btn_black_color" v-on:click="download()">下载历史数据</button>
                </div>
            </div>
            <div class="table_panel">
                <ul class="table_header">
                    <li class="largest middle_height">POS ID</li>
                    <li class="middle middle_height">毛利率</li>
                    <li class="small">价格折扣</li>
                    <li class="large">补货提前期（天）</li>
                    <li class="large">补货下单成本 （元/单）</li>
                    <li class="large">仓库配送成本 （元/件）</li>
                    <li class="large">店铺配送成本 （元/件）</li>
                    <li class="large">库存管理成本 （元/件）</li>
                    <li class="large">销售运营成本 （元/件）</li>
                </ul>
                <ul class="table_content">
                    <li class="table_line" v-for="item in parameterList">
                        <ul class="line_content">
                            <li class="largest middle_height">{{item.posId}}</li>
                            <li class="middle middle_height">{{item.grossMargin}}</li>
                            <li class="small">{{item.discount}}</li>
                            <li class="large">{{item.leadTime}}</li>
                            <li class="large">{{item.costOrder}}</li>
                            <li class="large">{{item.costInventory}}</li>
                            <li class="large">{{item.costTransporting}}</li>
                            <li class="large">{{item.costHold}}</li>
                            <li class="large">{{item.costSales}}</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!--<pagination :total="total" :current-page='current' @pagechange="pagechange"></pagination>-->
            <pagination v-if="pageStatus" v-bind:nums="numberLength" @setPage="gotoPage(arguments)" ref="Pagination"></pagination>
        </div>
        <page-footer v-bind:footerStatus="status" v-bind:next="nextUrl" v-bind:prev="prevUrl"></page-footer>
        <tip v-if="ifShow  && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
    </div>
</template>
<script>
import PageNavigation from "@/components/common/PageNavigation";
import PageFooter from "@/components/common/PageFooter";
import Pagination from "@/components/common/Pagination";
import Tip from "@/components/common/tip";
import { mapState, mapActions } from "vuex";
import {
  uploadParameterFile,
  downloadParmeterHistory,
  getParamterList,
  getTime
} from "../../util/api.js";

export default {
  name: "SettingParameter",
  components: { PageNavigation, PageFooter, Pagination, Tip },
  data() {
    return {
      ifShowB: false,
      BFocused: false,

      status: {
        type: "config",
        status: "middle"
      },
      prevUrl: "settingDays",
      nextUrl: "SettingWeeks",
      currentStep: 2,
      tableData: [],
      copyParameterList: [],
      time: "",
      pageStatus: false,
      sendStatus: false,
      sendMessage: "",
      currentPageSize: 10,
      currentIndex: 1
    };
  },
  computed: mapState({
    parameterList: state => state.parameterList,
    ifShow: state => state.ifShowMessage,
    numberLength: state => state.userLength
  }),
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
    that.getList();
    /*getParamterList()
      .then(function(res) {
        if (res.data) {
          that.pageStatus = true;
          that.copyParameterList = JSON.parse(JSON.stringify(res.data.result));
          that.$store.commit(
            "getParameterList",
            that.copyParameterList.slice(0, 10)
          );
          console.log(that.copyParameterList);
        } else {
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "获取门店运营参数失败";
        }
      })
      .catch(function(error) {
        that.$store.commit("getIfShowMessage", true);
        that.sendStatus = false;
        that.sendMessage = "获取门店运营参数失败";
      });*/
    that.getUploadTime();
  },
  methods: {
    gifShow() {
      this.ifShowB = true;
    },

    gifHidden() {
      if (!this.BFocused) {
        this.ifShowB = false;
      } else this.ifShowB = true;
    },

    gifMouseOver() {
      this.ifShowB = true;
      this.BFocused = true;
    },

    gifMouseLeave() {
      this.BFocused = false;
      this.ifShowB = false;
    },

    getUploadTime: function() {
      let that = this;
      getTime().then(function(res) {
        if (res.data.success) {
          that.time = that.getCurrentTime(res.data.result);
        }
      });
    },
    upload: function(e) {
      let that = this;
      const data = this.$refs.upload.files; // 获取文件对象
      if (data.length < 1) {
        return; // 检测是否有文件拖拽到页面
      }
      const formData = new FormData();
      formData.append("file", data[0], data[0].name);
      uploadParameterFile(formData)
        .then(function(res) {
          e.target.value = "";
          that.$store.commit("getIfShowMessage", true);
          if (res.data.success) {
            that.sendStatus = true;
            that.sendMessage = "上传成功";
            that.getList();
            that.getUploadTime();
            console.log(formData);
          } else {
            that.sendStatus = false;
            that.sendMessage = res.data.message ? res.data.message : "上传失败";
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "上传失败";
        });
    },
    download: function() {
      downloadParmeterHistory()
        .then(function(res) {
          let fileName = "门店参数历史数据";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(res.data, fileName + ".xlsx");
          } else {
            var a = document.createElement("a");
            a.download = fileName + ".xlsx";
            a.href = window.URL.createObjectURL(res.data);
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCurrentTime: function(datatime) {
      var offset = new Date().getTimezoneOffset() * 60 * 1000;
      var nowDate = new Date(
        Date.parse(datatime.slice(0, -2).replace(/-/g, "/"))
      ).getTime();
      var date = new Date(nowDate + 8 * 60 * 60 * 1000);
      var Str =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      return Str;
    },
    gotoPage: function(page) {
      console.log(page[0], page[1]);
      console.log(this.copyParameterList.slice(page[0], page[1]));
      this.$store.commit(
        "getParameterList",
        this.copyParameterList.slice(page[0] - 1, page[1])
      );
      this.currentPageSize = page[2];
      this.currentIndex = page[3];
    },
    getList: function() {
      let that = this;
      getParamterList()
        .then(function(res) {
          if (res.data.success) {
            if (res.data.result.length != 0) {
              that.pageStatus = true;
              that.copyParameterList = JSON.parse(
                JSON.stringify(res.data.result)
              );
              let start = (that.currentIndex - 1) * that.currentPageSize;
              let end = that.currentIndex * that.currentPageSize;
              if (that.copyParameterList.length < start) {
                start = 0;
                end = that.currentPageSize;
              }
              that.$store.commit(
                "getParameterList",
                that.copyParameterList.slice(start, end)
              );
              that.$store.commit(
                "getUserLength",
                that.copyParameterList.length
              );
              if (that.$refs && that.$refs.Pagination) {
                that.$refs.Pagination.getPageList();
              }
              console.log(that.copyParameterList);
            } else {
              that.$store.commit("getParameterList", []);
            }
          } else {
            that.$store.commit("getIfShowMessage", true);
            that.sendStatus = false;
            that.sendMessage = "获取门店运营参数失败";
          }
        })
        .catch(function(error) {
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "获取门店运营参数失败";
        });
    }
  }
};
</script>
<style scoped>
li {
  list-style: none;
}
.nav {
  padding: 0.1rem 0 0.1rem 0;
}
@media screen and (max-height: 650px) {
  .content_main {
    background-color: #fff;
    width: 10rem;
    height: 5.99rem;
    margin: 0 auto;
    margin-bottom: 0.77rem;
    padding-top: 0.19rem;
    box-shadow: 0 0 5px -3px #000;
    position: relative;
  }
}
@media screen and (min-height: 650px) {
  .content_main {
    background-color: #fff;
    width: 10rem;
    height: 5.99rem;
    padding-top: 0.19rem;
    margin-top: 0.2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    box-shadow: 0 0 5px -3px #000;
  }
}
.content_main h3 {
  text-align: left;
}
.line_blue:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 0.24rem;
  background-color: #fa5400;
}
.top_panel {
  display: flex;
  padding: 0.1rem 0.22rem 0.1rem 0.26rem;
}
.top_panel_left {
  line-height: 0.36rem;
}
.top_panel_right {
  flex: 1;
  text-align: right;
}
.btn {
  width: 1.17rem;
  height: 0.36rem;
  cursor: pointer;
}
.btn_small {
  width: 1.06rem;
  height: 0.36rem;
  cursor: pointer;
}
.btn_black_color {
  background-color: #fff;
  color: #000;
  border: 1px solid #000;
  border-radius: 2px;
  font-size: 0.15rem;
}
.table_panel {
  padding-left: 0.26rem;
  padding-right: 0.22rem;
}
.table_header,
.line_content {
  overflow: hidden;
  background-color: #eeeeee;
}
.table_header li {
  background-color: #eeeeee;
  border-right: 2px solid #fff;
}
.table_header li,
.line_content li {
  float: left;
  padding: 0.05rem 0.1rem;
  text-align: center;
  height: 0.45rem;
}
.table_content {
  height: 4.05rem;
  overflow: auto;
}
.small{
  width: 0.6rem;
}
.middle {
  width: 0.7rem;
}
.largest{
  width: 1.5rem;
}
.table_header .middle_height{
  line-height: 0.33rem;
}
.large {
  width: 1.12rem;
}
.table_line li {
  line-height: 0.33rem;
  border-right: 2px solid #fff;
}
.table_header li:last-child,
.table_line li:last-child {
  border: 0;
}
.table_line:nth-child(n) ul {
  background-color: #fff;
}
.table_line:nth-child(2n) ul {
  background-color: #f9f9f9;
}
.line_content li:last-child {
  width: 1rem;
}
.element-a:hover {
  cursor: pointer;
  opacity: 1;
}
.gif {
  width: 800px;
  height: 480px;
}
.gif-wrap {
  font-size: 1rem;
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  -ms-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}
.gif-wrap:hover {
  cursor: pointer;
  opacity: 1;
}
input {
  display: none;
}
.btn_label {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  line-height: 0.36rem;
}
.btn:hover {
  font-weight: bold;
  border: 1px solid #fa5400;
}
</style>


// WEBPACK FOOTER //
// src/components/page/SettingParameter.vue